import { styled } from '@mui/material/styles';
import { Typography, Paper } from '@mui/material';

const PREFIX = 'TripPreferencesFormInstructions';

const classes = {
  container: `${PREFIX}-container`,
  section: `${PREFIX}-section`,
};

const Root = styled(Paper)(({ theme }) => ({
  [`&.${classes.container}`]: {
    backgroundColor: 'rgba(1, 16, 18, 0.04)',
    padding: theme.spacing(2),
    height: 'fit-content',
    width: 564,
    marginLeft: 12,
    marginRight: 'auto',
    overflowY: 'auto',
  },
  [`& .${classes.section}`]: {
    textDecoration: 'underline',
    fontWeight: 600,
  },
}));

export default function TripPreferencesFormInstructions() {
  return (
    <Root className={classes.container}>
      <Typography mt={2} mb={2} variant="h4">
        Support for this page
      </Typography>
      <Typography variant="h6">
        We want to make sure we can provide your business with the best possible
        experience. We will utilize this page to keep track of your business
        preferences and setup. Getting to know your business through this detail
        will also help us as our business grows. Feel free to update this at any
        time to give us the most up-to-date information about your business.
      </Typography>
      <Typography variant="h6" className={classes.section} mt={2}>
        Coverage Area
      </Typography>
      <Typography variant="h6">
        -Primary - Please provide us with the primary city you do business in.
        <br />
        -Other - Include any additional information about the area that you
        cover including any cities or counties where you do business.
      </Typography>
      <Typography variant="h6" className={classes.section} mt={2}>
        Hours of Operation
      </Typography>
      <Typography variant="h6">
        -Help us know the times of the day and days of the week that you operate
        the business.
      </Typography>
      <Typography variant="h6" className={classes.section} mt={2}>
        Vehicles
      </Typography>
      <Typography variant="h6">
        -Please provide us with the types of vehicles you operate and how many
        you might have on the road. This information will help us understand the
        types of trips that your business services.
      </Typography>
      <Typography variant="h6" className={classes.section} mt={2}>
        Total Trips
      </Typography>
      <Typography variant="h6">
        -Help us understand your threshold of trips for a day. We do not want to
        put your business in a situation where we have too many trips setup that
        you cannot handle.
      </Typography>
    </Root>
  );
}
